import React, {useContext, useEffect, useState} from "react";
import AuthContext from "../../context/AuthContext";
import {Link, useLocation, useNavigate} from "react-router-dom";
import LiUserMenuButton from "../LiUserMenuButton/LiUserMenuButton";
import messageIcon from "../../assets/icons/message.svg"
import account from '../../assets/icons/account-solid.svg'
import alertIcon from "../../assets/icons/alarm.svg"
import favoriteIcon from "../../assets/icons/hearth-black.svg"
import bookingIcon from "../../assets/icons/booking.svg"
import standIcon from "../../assets/icons/stand.svg"
import spotGroupIcon from "../../assets/icons/spot-group.svg"
import companyIcon from "../../assets/icons/company.svg"
import accountIcon from "../../assets/icons/account.svg"
import logoutIcon from "../../assets/icons/logout.svg"
import myStandplaatsIcon from "../../assets/icons/favicon.svg"
import cogIcon from "../../assets/icons/cog-blue.svg";
import useFunction from "../../hooks/useFunction";
import useAuthService from "../../api/services/useAuthService";
import {useAppContext} from "../../context/AppContextProvider";
import Media from "../Media/Media";
import swal from "sweetalert";
import useUserService from "../../api/services/useUserService";

const UserButton = () => {

  const {objIsEmpty} = useFunction()
  const {user, setUser} = useContext(AuthContext)
  const {logout} = useAuthService()
  const [isHovered, setIsHovered] = useState(false)
  const navigate = useNavigate();
  const {notifications} = useAppContext()
  const {isTouchScreen, ConditionalWrapper} = useFunction()
  const location = useLocation()
  const {userSwitchActiveCompany} = useUserService();


  useEffect(() => {
    setIsHovered(false)
  }, [location.pathname])

  const onMouseEnter = () => {
    setIsHovered(true)
  }

  const onMouseLeave = () => {
    setIsHovered(false)
  }

  const handleClickMessages = () => {
    navigate('/user/berichten')
  }

  const handleClick = () => {
    setIsHovered(true)
  }

  /**
   * @param e
   */
  const logoutSubmit = (e) => {
    e.preventDefault()
    logout((response) => {
      navigate('/')
      setUser(false)
    }, () => {})
  }

  return (
    <div className="component-user-button" data-testid="user-button" onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      {notifications !== 0 &&
        <div onClick={handleClickMessages} className="notifications">{notifications}</div>
      }
      <div className="menu-user-button" data-testid="menu-user-button">
        <ConditionalWrapper
          condition={isTouchScreen()}
          wrapperA={children => <div onClick={handleClick}>{children}</div>}
          wrapperB={children => <Link
            to={(objIsEmpty(user)) ? '/wizard/welkom/start' : '/user/mijn-standplaats'}
            state={(objIsEmpty(user))
              ?{buttonPrev:{start:{onClick:{navigate:location.pathname}}}}
              :{}
            }>{children}</Link>}
        >
          <div className={(!objIsEmpty(user) && user.is_admin && user.active_company_id && user.active_company_id !== 1)?"square-button alien":"square-button"}>
            <div className="company-name">
              {
                !objIsEmpty(user) &&
                'active_company' in user &&
                user.active_company &&
                'legal_name' in user.active_company &&
                user.active_company.legal_name
                  ? user.active_company.legal_name
                  : 'Aan de slag!'
              }
            </div>
            <div className="user-name">
              {objIsEmpty(user) ? 'Login/registreer' : user.first_name}
            </div>
          </div>
          <div className="round-button">
            {
              !objIsEmpty(user) &&
              'avatar_media' in user &&
              user.avatar_media
                ? <Media className="avatar-user-image" media={user.avatar_media} size={'logo'} alt="Avatar"/>
                : <img className="avatar-placeholder" src={account} alt="Avatar"/>
            }
          </div>
        </ConditionalWrapper>


        {isHovered &&
          <div className="sub-menu-user-button">
            <ul>
              {!objIsEmpty(user)
                ?
                <>
                  <LiUserMenuButton
                    to="/user/mijn-standplaats"
                    title="Overzichtspagina van uw account"
                    label="Mijn Standplaats"
                    icon={myStandplaatsIcon}
                  />
                  <LiUserMenuButton
                    to="/user/berichten"
                    title="Notificaties, Berichten, Contact"
                    label="Berichten"
                    icon={messageIcon}
                  />
                  <LiUserMenuButton
                    to="/user/zoek-alerts"
                    title=""
                    label="Alert Meldingen"
                    icon={alertIcon}
                  />
                  <LiUserMenuButton
                    to="/user/favorieten"
                    title="Favoriete stands, locaties enz."
                    label="Favorieten"
                    icon={favoriteIcon}
                  />
                  <LiUserMenuButton
                    to="/user/boekingen"
                    title="Boekingen van of naar accounts/organisaties waarvoor je werkt, bezit of vertegenwoordigd"
                    label="Boekingen"
                    icon={bookingIcon}
                  />
                  <LiUserMenuButton
                    to="/user/stands"
                    title="Jouw foodtrucks, marktkraam, mobiele onderneming of andere stands"
                    label="Stands & trucks"
                    icon={standIcon}
                  />
                  <LiUserMenuButton
                    to="/user/locaties"
                    title="Jouw events, markten, braderien, supermarkten of andere locaties"
                    label="Locaties"
                    icon={spotGroupIcon}
                  />
                  <LiUserMenuButton
                    to="/user/organisaties"
                    title="Accounts/organisaties waarvoor je werkt, bezit of vertegenwoordigd"
                    label="Account/organisatie"
                    icon={companyIcon}
                  />
                  {/*<LiUserMenuButton*/}
                  {/*  to="/user/notificaties"*/}
                  {/*  title="Al jouw persoonlijke/account/login gegevens"*/}
                  {/*  label="Emails & Meldingen"*/}
                  {/*  icon={emailIcon}*/}
                  {/*/>*/}
                  <LiUserMenuButton
                    to="/user/account"
                    title="Al jouw persoonlijke/account/login gegevens"
                    label="Gebruiker"
                    icon={accountIcon}
                  />

                  {!objIsEmpty(user) && user.is_admin &&
                    <>
                      <hr/>
                      <LiUserMenuButton
                        to="/user/admin"
                        title="Admin"
                        label="Admin"
                        icon={cogIcon}
                      />
                      {user.active_company_id !== 1 &&
                        <LiUserMenuButton
                          to="#"
                          title="Switch -> St.pl.nl"
                          label="Switch -> St.pl.nl"
                          icon={cogIcon}
                          onClick={() => {
                            swal({
                              title: "Aan het schakelen...",
                              text: "Een moment geduld",
                              icon: "info",
                              buttons: false,
                              closeOnClickOutside: false,
                              closeOnEsc: false,
                            });
                            userSwitchActiveCompany(
                              () => {
                                // swal.close();
                                swal({
                                  title: "Geswitched",
                                  icon: "success",
                                  timer: 1000,
                                  buttons: false,
                                });
                              },
                              () => {
                                // swal.close();
                                swal({
                                  title: "Er ging iets mis",
                                  text: "Probeer het opnieuw",
                                  icon: "error",
                                  timer: 1000,
                                  buttons: false,
                                });
                              },
                              1
                            );
                          }}
                        />
                      }

                    </>
                  }

                  <hr/>
                  <li className="logout">
                    <div
                      className="logout-button"
                      onClick={logoutSubmit}
                    ><img src={logoutIcon} alt="Uitloggen"/> Uitloggen
                    </div>
                  </li>
                </>
                :
                <>
                  <li className="primary"><Link
                    to="/wizard/welkom/start"
                    title="Aan de slag"
                    state={{buttonPrev:{start:{onClick:{navigate:location.pathname}}}}}
                  >Aan de slag</Link></li>
                  <li><Link
                    to="/inloggen"
                    title="Inloggen"
                  >Inloggen</Link></li>
                  <hr/>
                  <li><Link
                    to="/hoe-werkt-het/"
                    title="Hoe werkt het?"
                  >Hoe werkt het?</Link></li>
                  <li><a
                    href="/service/help/"
                    title="Help"
                  >Help</a></li>
                  {/*<hr/>*/}
                  {/*<li><a*/}
                  {/*  href="/standplaats-huren/zoek-een-standplaats/"*/}
                  {/*  title="Ik heb een stand of truck"*/}
                  {/*>Ik heb een stand of truck</a></li>*/}
                  {/*<li><a*/}
                  {/*  href="/stand-truck-huren/locatie-verhuren/"*/}
                  {/*  title="Ik heb een locatie"*/}
                  {/*>Ik heb een locatie</a></li>*/}
                </>
              }
            </ul>
          </div>
        }
      </div>
    </div>
  )
}

export default UserButton
